import { BehaviorSubject, Observable } from 'rxjs';
import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { catchError, finalize } from 'rxjs/operators';

import { of } from 'rxjs';
import { CalibrationBalanceAudit, CalibrationBalanceAuditFilter } from './calibrationBalance';
import { CalibrationBalanceService } from '../services/calibrationBalance.service';

export class CalibrationBalanceAuditDataSource implements DataSource<CalibrationBalanceAudit> {

    private calibrationsSubject = new BehaviorSubject<CalibrationBalanceAudit[]>([]);
    private loadingSubject = new BehaviorSubject<boolean>(false);
    private totalSubject = new BehaviorSubject<number>(0);

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public loading$ = this.loadingSubject.asObservable();
    // eslint-disable-next-line @typescript-eslint/member-ordering
    public totalItems$ = this.totalSubject.asObservable();

    constructor(private service: CalibrationBalanceService) { }

    connect(_collectionViewer: CollectionViewer): Observable<CalibrationBalanceAudit[]> {
        return this.calibrationsSubject.asObservable();
    }

    disconnect(_collectionViewer: CollectionViewer): void {
        this.calibrationsSubject.complete();
        this.loadingSubject.complete();
        this.totalSubject.complete();
    }

    loadCalibrationAudit(id: number, filter = new CalibrationBalanceAuditFilter()): void {

        this.loadingSubject.next(true);

        this.service.getAudit(id, filter).pipe(
            catchError(() => of([])),
            finalize(() => this.loadingSubject.next(false))
        ).subscribe(data => {
            if (data && data.content) {
                this.calibrationsSubject.next(data.content as CalibrationBalanceAudit[]);
                this.totalSubject.next(data.totalElements as number);
            } else if (data) {
                this.calibrationsSubject.next(data as CalibrationBalanceAudit[]);
                this.totalSubject.next(data.length as number);
            } else {
                this.calibrationsSubject.next([]);
                this.totalSubject.next(0);
            }
        });
    }
}
